import 'boxicons';
import './index.css';
import Parse from 'parse';
import MyMenu from './menu';
import MyList from './list';
import MyTable from './table';
import DetailModal from './detailModal';
import React, { useState, useEffect, useRef, createRef } from 'react';
import { primaryColors, secondaryColors } from '../common/colors';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Layout, Button, Spin, Tooltip, ConfigProvider, Image } from 'antd';

const { Header, Content, Footer, Sider } = Layout; 

const Catalog = () => {
  const componentRef = useRef();
  const itemsRef = useRef([]);

  // Handle menu
  const [menu, setMenu] = useState('category'); // Show differents views
  const [lastMenu, setLastMenu ] = useState('category');

  // Handle Sider
  const [collapsed, setCollapsed] = useState(false); // Open and close menu

  // Handle query
  const [ isLoading, setIsLoading ] = useState(true);
  const [ results, setResults ] = useState([]);

  // Handle table view
  const [ columns, setColumns ] = useState([]);
  const [ data, setData ] = useState([]);

  // Handle categories view
  const [ dataList, setDataList ] = useState([]);

  // Handle modal form
  const [ visible, setVisible ] = useState(false);

  // Handle print
  const [print, setPrint] = useState(false);
  const [height, setHeight] = useState([]);


  // Query
  async function queryOrder() {
    setIsLoading(true);

    const mainQuery = new Parse.Query("Product");
    mainQuery.ascending("name");
    mainQuery.equalTo("outdated", false);
    let res = await mainQuery.find();

    setTimeout(() => {
      setResults(res);
      setIsLoading(false);
    }, 1000);
  }

  // Order results
  const sort = (arr, variable) => {
    const sortedArray = arr.sort(function(a, b) {
      if ( a[variable] < b[variable] ) return -1;
      if ( a[variable] > b[variable] ) return 1;
      return 0;
    });
    return sortedArray;
  };

  const getCellColor = (title) => {
    let customStyle = { background: secondaryColors.white, color: primaryColors.grey, textAlign: 'center' };

    if(title.toLowerCase().includes('brote')) {
      customStyle = { background: secondaryColors.blue, color: primaryColors.grey, textAlign: 'center' };
    }
    else if(title.toLowerCase().includes('flor exótica')) {
      customStyle = { background: secondaryColors.red, color: 'white', textAlign: 'center' };
    }
    else if(title.toLowerCase().includes('hoja baby')) {
      customStyle = { background: secondaryColors.yellow, color: primaryColors.grey, textAlign: 'center' };
    }
    else if(title.toLowerCase().includes('hoja premium')) {
      customStyle = { background: secondaryColors.green, color: primaryColors.grey, textAlign: 'center' };
    }
    else if(title.toLowerCase().includes('product')) {
      customStyle = { fontSize: '1.1rem' };
    }
    else if(title.toLowerCase().includes('title')) {
      customStyle = { background: primaryColors.blue, color: 'white', textAlign: 'center', fontSize: '1.2rem' };
    }
    return ({ style: customStyle });
  };

  const orderResults = () => {
    let myCategories = [];
    let myColumns = [];
    let myData = [];
    let myList = [];
    let counter = 0;

    results.forEach(res => {
      const newEntry = { 'product': res.get('name'), key: counter++ };

      if(res.get('specificationFile')?._url !== undefined) newEntry.datasheet = res.get('specificationFile')?._url;

      res.get('presentation').forEach(pr => {
        newEntry[pr.title] = 'X';//'$' + pr.retailPrice + '/' + pr.unit;

        if(!myCategories.includes(pr.title)) {
          myCategories.push(pr.title);
          myColumns.push({
            key: pr.title,
            title: pr.title,
            dataIndex: pr.title,
            width: '10%',
            render: (text) => <b>{text}</b>,
            onHeaderCell: (record) => { return getCellColor('title'); },
            onCell: (record) => { return getCellColor(pr.title); }
          });
          myList.push({'name': pr.title, 'products': [{ name: res.get('name'), 'price': pr.retailPrice, 'unit': pr.unit, url: res.get('specificationFile')?._url }]});
        }
        else{
          myList.forEach(el => {
            if(el.name === pr.title) el.products.push({ name: res.get('name'), 'price': pr.retailPrice, 'unit': pr.unit, url: res.get('specificationFile')?._url });
          });
        }
      });
      myData.push(newEntry);
    });

    setDataList(sort(myList, 'name'));
    setData(myData);
    setColumns([{
      title: 'Producto',
      dataIndex: 'product',
      key: 'product',
      fixed: 'left',
      onHeaderCell: (record) => { return getCellColor('title'); },
      onCell: (record) => { return getCellColor('product'); },
      render: (text) => <b>{text}</b>
    }, 
    {
      title: 'Ficha',
      dataIndex: 'datasheet',
      key: 'datasheet',
      width: '5%',
      onHeaderCell: (record) => { return getCellColor('title'); },
      onCell: (record) => { return getCellColor(''); },
      render: (text) => {
        if(text!== undefined && text.startsWith('http')) {
          return (<Tooltip title="Ver la ficha técnica"><a href={text} target="_blank"><box-icon type='solid' color={primaryColors.green} name='spreadsheet'/></a></Tooltip>);
        }
      }
    },
    ...sort(myColumns, 'title')
  ]);    
  };

  // Use Effects
  useEffect(() => {
    queryOrder();
  }, []);

  useEffect(() => {
    if(results!==undefined && results.length>0) orderResults();
  }, [results]);

  useEffect(() => {
    if (itemsRef.current.length !== dataList.length) {
      // add or remove refs
      itemsRef.current = Array(dataList.length)
        .fill()
        .map((_, i) => itemsRef.current[i] || createRef());

        setHeight(itemsRef.current.map(() => 0));
    }
 }, [dataList]);

  useEffect(() => {
    if(menu==='category') setLastMenu('category');
    else if(menu==='table') setLastMenu('table');
    else if(menu==='contactUs') {
      setVisible(true);
      setMenu(lastMenu);
    }
  }, [menu]);

  useEffect(() => {
    const arrHeight = [];
    const heightLetter = 1050;
    let actualHeight = 0;
    itemsRef.current.forEach((iRef, i) => {
      if (!iRef.current) {
        // we do not initialize the observer unless the ref has
        // been assigned
        return;
      }
      
      if(i===0){
        actualHeight += iRef.current.offsetHeight;
        if(actualHeight>heightLetter) actualHeight = actualHeight % heightLetter;
        arrHeight.push(0);
      }
      else {
        if(actualHeight + iRef.current.offsetHeight> heightLetter){
          arrHeight[i-1] = heightLetter - actualHeight;
          actualHeight += iRef.current.offsetHeight;
          actualHeight = actualHeight % heightLetter;
          arrHeight.push(0);
        } else {
          actualHeight += iRef.current.offsetHeight;
          if(actualHeight>heightLetter) actualHeight = actualHeight % heightLetter;
          arrHeight.push(0);
        }
      }
    });
    setHeight(arrHeight);
  },
  // only update the effect if the ref element changed
  [itemsRef.current])

  // Callbacks
  const handleBeforeGetContent = () => {
    setPrint(true);
    return Promise.resolve();
  };

  const handleAfterPrint = () => {
      setPrint(false);
      return Promise.resolve();
  };

  const triggerPrint = () => {
          return  <div style={{textAlign: 'center', marginTop: 10 }}>
                      <Button type="default">Imprimir</Button>
                  </div>
  }

  const onClose = () => setVisible(false);

  const selectDataFormat = () => {
    const actualDate = new Date();

    const printElements = {
      header: (text) => (<div style={{textAlign: 'center', margin: 10, color: primaryColors.grey, fontSize: '1.5rem', fontWeight: 'bold', fontFamily: 'Spoof_Medium'}}>{text}</div>),
      date: <div style={{textAlign: 'center', color: primaryColors.grey }}>Fecha: {actualDate.toLocaleDateString()}</div>,
      advertise: <div style={{textAlign: 'center', color: primaryColors.grey }}>* Sujeto a cambios sin previo aviso</div>,
      handleBeforeGetContent,
      handleAfterPrint,
      triggerPrint
    };

    if(lastMenu === 'table'){
      return MyTable({
        columns, 
        dataSource: data, 
        printElements, 
        ref: componentRef
      });

    }
    else if(lastMenu === 'category'){
      return MyList({
        dataSource: dataList,
        printElements,
        ref: componentRef,
        itemsRef: itemsRef,
        height: height
      });
    }
  }

  const showContent = () => {
    if(isLoading || results===undefined){
      return (
        <div style={{ textAlign: 'center', margin: 10 }}>
            <Spin size="large"/>
        </div>
      );
    }
    return <>
              <DetailModal visible={visible} onClose={onClose}/>
              {selectDataFormat()}
              <div style={{textAlign: 'center', marginTop: 10 }}>
                  <Button type="primary" onClick={() => setVisible(true)}>Solicitar cotización</Button>
              </div>
           </>;
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#00783e', // primary color for all components
          colorLink: '#52c41a', // link color
          colorSuccess: '#52c41a', // success state color
          colorWarning: '#faad14', // warning state color
          colorError: '#f5222d', // error state color
          fontSize: '14px', // major text font size
          colorTextHeading: 'rgba(0, 0, 0, 0.85)', // heading text color
          colorText: 'rgba(0, 0, 0, 0.65)', // major text color
          colorTextSecondary: 'rgba(0, 0, 0, 0.45)', // secondary text color
          colorTextQuaternary: 'rgba(0, 0, 0, 0.25)', // disable state color
          borderRadius: '2px', // major border radius
          colorBorder: '#d9d9d9', // major border color
        },
      }}
    >
      <Layout style={{minHeight: "100vh"}}>
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
          trigger={null} 
          collapsible
          collapsed={collapsed}
          onBreakpoint={(broken) => {
            setCollapsed(broken);
          }}
          onCollapse={(collapsed, type) => {
            console.log("collapsed menu in dashboard", collapsed, type);
          }}
        >
          <div className="welcomeSider">Bienvenido</div>
          {MyMenu({ setMenu })}
        </Sider>
        <Layout className="principalLayout">
          <Header className="site-layout-sub-header-background titleBar">
              {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                className: 'trigger',
                onClick: () => setCollapsed(!collapsed),
              })}
              {<Image style={{marginBottom: 25}} preview={false} src={'/catalogo/img/Ecolistico/eco-white.png'} alt={'Ecolistico'} width={200} height={40}/>}
              <div></div>   
          </Header>
          <Content>
              {showContent()}
          </Content>
          <Footer className="footer">
            Ecolistico ©2019 Todos los derechos reservados
          </Footer>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
}


export default Catalog;